var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":20,"offset":2}},[_c('el-card',{staticClass:"card",attrs:{"shadow":"hover"}},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }